import React from "react";
import { Link } from "react-router-dom";
import {
  TenantMgmtIcon,
  RentTrackingIcon,
  AiCallingIcon,
  NotificationsIcon,
  DashboardIcon,
  PaymentTrackingIcon,
  AlertsIcon,
  CommunicationIcon,
} from "../landing/icons/SvgIcons";
import SeoHead from "../components/SeoHead";

const features = [
  { icon: DashboardIcon, title: "Live dashboard", text: "See occupancy, collection rates, overdue counts, and outstanding balances across all properties in real time. Filter by property or month." },
  { icon: TenantMgmtIcon, title: "Tenant management", text: "Add, edit, vacate, and delete tenants. Track move in history, deposits, notes, and full lifecycle from onboarding to move out." },
  { icon: RentTrackingIcon, title: "Smart rent tracking", text: "Record full, partial, or multi month payments. Balances carry forward automatically, with no manual calculations needed." },
  { icon: AlertsIcon, title: "Automatic overdue detection", text: "Paysafi detects overdue rent the moment the due date passes. Arrears from previous months are flagged automatically." },
  { icon: AiCallingIcon, title: "AI voice agent", text: "Let an AI agent call tenants about their outstanding rent. Transcripts and notes are recorded for every call." },
  { icon: NotificationsIcon, title: "SMS reminders", text: "Send individual or bulk SMS reminders with smart templates that adapt to each tenant's payment status." },
  { icon: PaymentTrackingIcon, title: "Payment history", text: "Full audit trail per tenant and per house unit. See every payment, void, deposit, note, SMS, and AI call in a timeline." },
  { icon: CommunicationIcon, title: "Tenant notes", text: "Record promises, follow ups, and communications against each tenant. Notes are timestamped in the history." },
];

export default function FeaturesPage() {
  return (
    <article>
      <SeoHead
        title="Features"
        description="Paysafi features: live dashboard, smart rent tracking, automatic overdue detection, AI voice calls, SMS reminders, tenant management, and payment history, all built for Kenyan landlords."
        path="/features"
      />
      <section className="border-b border-gray-100 dark:border-gray-800 bg-gray-50 dark:bg-gray-900 py-16 sm:py-20">
        <div className="mx-auto max-w-3xl px-4 text-center sm:px-6">
          <h1 className="text-4xl font-bold tracking-tight text-gray-900 dark:text-white sm:text-5xl">
            Features built for landlords
          </h1>
          <p className="mt-4 text-lg text-gray-600 dark:text-gray-400">
            Paysafi is the rent management software Kenya's landlords trust to track tenants, collect rent, and follow up automatically.
          </p>
        </div>
      </section>
      <section className="py-14 sm:py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid gap-8 sm:grid-cols-2 sm:gap-10">
            {features.map((f) => (
              <div key={f.title} className="flex gap-4 sm:gap-5">
                <div className="flex-shrink-0">
                  <f.icon size={56} bg="#EEF2FF" />
                </div>
                <div className="min-w-0">
                  <h2 className="text-base font-semibold text-gray-900 dark:text-white sm:text-lg">{f.title}</h2>
                  <p className="mt-1.5 text-sm leading-relaxed text-gray-600 dark:text-gray-400">{f.text}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="mt-16 text-center">
            <Link to="/signup" className="btn-primary text-base px-6 py-3">
              Try Paysafi
            </Link>
          </div>
        </div>
      </section>
    </article>
  );
}
